/* eslint-disable */

import React, { useState } from "react";

import ModelTag from "../model-tag/model-tag";

import RaindropDropdown from "../raindrop-dropdown/raindrop-dropdown";

import RaindropCard from "../raindrop-card/raindrop-card.tsx";
import RaindropButton from "../raindrop-button/raindrop-button.tsx";
import Spacer from "../spacer/spacer.js";
import JSONBlob from "../json-blob/json-blob.tsx";
import RaindropDivider from "../raindrop-divider/raindrop-divider.js";

const ModelComponent = ({
  modelId,
  dropdownComponent = null,
  colorBorderAccent = "border-color-dark-model-organisation-user",
  rawData = null,
  isDefaultExpanded = false,
  helperText = null,
  children,
}) => {
  const [isShowingRawData, setIsShowingRawData] = useState(false);
  const [isExpanded, setIsExpanded] = useState(isDefaultExpanded);

  let chevron = "fa-chevron-right";

  if (isExpanded) {
    chevron = "fa-chevron-down";
  }

  return (
    <RaindropCard colorBorderAccent={colorBorderAccent}>
      <div
        className={`flex flex-col gap-4 w-full max-w-lg  rounded-lg text-color-text-primary dark:text-color-dark-text-primary
      `}
      >
        <div className="flex flex-col">
          <div className="flex flex-row items-center gap-2">
            <ModelTag modelId={modelId} />

            {helperText && (
              <>
                <RaindropDivider isVertical={true} />
                <p className="text-left whitespace-nowrap text-color-text-tertiary text-xs truncate w-full">
                  {helperText}
                </p>
              </>
            )}

            <div className="flex flex-row ml-auto">
              {rawData && (
                <RaindropButton
                  isHidingTitle={true}
                  onClick={() => setIsShowingRawData(!isShowingRawData)}
                  icon="fa-code"
                />
              )}

              {dropdownComponent && (
                <RaindropDropdown>{dropdownComponent}</RaindropDropdown>
              )}

              <RaindropButton
                isHidingTitle={true}
                onClick={() => setIsExpanded(!isExpanded)}
                icon={chevron}
              />
            </div>
          </div>
        </div>

        {isExpanded && <div className="flex flex-col gap-2">{children}</div>}

        {isShowingRawData && <JSONBlob data={rawData} />}
      </div>
    </RaindropCard>
  );
};

export default ModelComponent;
